<script>
	import icons from './images';
	let { name, class: className } = $props();
	if (!icons[name]) {
		throw new Error(`Icon ${name} not found`);
	}
</script>

<div class={['inline-block', className]}>
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html icons[name]}
</div>
